import { z } from 'zod'

export const schema = z.object({
  id: z.number(),
  attributes: z.object({
    publishedAt: z.string().nullable(),
    content: z.string().min(1),
    head: z.object({
      id: z.number(),
      title: z.string().min(1),
      description: z.string().min(1),
      image: z.object({
        data: z.object({
          id: z.number(),
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
    }),
    hero: z.object({
      id: z.number(),
      title: z.string().min(1),
      text: z.string().min(1),
      image: z.object({
        data: z.object({
          id: z.number(),
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
    }),
  }),
})

export type schemaType = z.infer<typeof schema>
